import _ from 'lodash';

class SectionContent {
    
    constructor(data) {

        this.content = [];

        data.edges.forEach(edge => {
            this.content[_.camelCase(edge.node.contentType)] = edge.node.content;
        });
    }

    getContent(key) {
        return this.content[key].childMarkdownRemark;
    }
}

export default SectionContent;
  